import * as types from '../constants/dictionaries';
import localStorage from 'store';

const initialState = {
  dictionaries: localStorage.get('dictionaries') || [],
  isLoading: 0,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_LOADER:
      return {
        ...state,
        isLoading: payload ? state.isLoading + 1 : state.isLoading - 1,
      };
    case types.SET_LIST:
      return {
        ...state,
        dictionaries: payload,
      };
    default:
      return state;
  }
};

export default reducer;
